import React from 'react';
import cx from './cx';

const TONE_CLASS = {
  info: 'rg-message--info',
  success: 'rg-message--success',
  warning: 'rg-message--warning',
  error: 'rg-message--error'
};

function MessageBlock({
  as: Component = 'section',
  title,
  children,
  tone = 'info',
  actions,
  className,
  role,
  ...props
}) {
  const effectiveRole = role || (tone === 'error' || tone === 'warning' ? 'alert' : 'status');
  const ariaLive = tone === 'error' || tone === 'warning' ? 'assertive' : 'polite';

  return (
    <Component
      className={cx('rg-message', TONE_CLASS[tone] || TONE_CLASS.info, className)}
      role={effectiveRole}
      aria-live={ariaLive}
      {...props}
    >
      {title && <h3 className="rg-message__title">{title}</h3>}
      {children && <p className="rg-message__body">{children}</p>}
      {actions && <div className="rg-message__actions">{actions}</div>}
    </Component>
  );
}

export default MessageBlock;
